import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';

document.addEventListener('DOMContentLoaded', () => {
	/* 代表取締役コメント モーダル */
	const modal = document.querySelector('.js_commentModal');
	if (modal) {
		document.querySelector('.js_commentModalOpen').addEventListener('click', () => {
			modal.classList.add('is-open');
			modal.setAttribute('aria-hidden', 'false');
			document.body.style.overflow = 'hidden';
		});
		modal.querySelectorAll('.js_commentModalClose').forEach((el) => {
			el.addEventListener('click', () => {
				modal.classList.remove('is-open');
				modal.setAttribute('aria-hidden', 'true');
				document.body.style.overflow = '';
			});
		});
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && modal.classList.contains('is-open')) {
				modal.classList.remove('is-open');
				modal.setAttribute('aria-hidden', 'true');
				document.body.style.overflow = '';
			}
		});
	}

	/* メインイメージのアニメーション用 */
	const $ = window.jQuery;
	if ($) {
		const $window = $(window);
		const $mv = $('.js_mv');
		$window.on('load', () => {
			$mv.addClass('is_loaded');
		});
	}

	/* 施設スライダー */
	new Swiper('.js_facilitySlider', {
		loop: true,
		navigation: {
			nextEl: '.js_facilityNext',
			prevEl: '.js_facilityPrev',
		},
		on: {
			slideChange: function slideChange() {
				const slide = this.slides[this.activeIndex];
				document.querySelector('.js_facilityTitle').textContent = slide.dataset.title;
				document.querySelector('.js_facilityDesc').textContent = slide.dataset.desc;

				const prevBtn = document.querySelector('.js_facilityPrev');
				prevBtn.classList.toggle('is-active', this.realIndex > 0);

				const totalSlides = [...this.slides].filter(s => !s.classList.contains('swiper-slide-duplicate')).length;
				const nextBtn = document.querySelector('.js_facilityNext');
				nextBtn.classList.toggle('is-last', this.realIndex === totalSlides - 1);
			},
		},
	});
});
